const LegalState = {
  members: {},
  selectedRow: null,
  action: null,
  destroyMemberDialogIsOpen: false,
  addMemberDialogIsOpen: false
};

export default LegalState;
